export enum PreviewSupportedFileType {
  Pdf = 'pdf',
  Image = 'image',
  Csv = 'csv',
}
